import axios from "axios";

export const loginAction = async (payload) => {
  console.log(payload, "payload auth body");
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/affiliates/affiliateLogin`,
    payload.body,
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
// console.log(response,"<-------response login authentication");
  return response;
};

export const accessTokenAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/user/access_Token?affiliateEmail=${payload.affiliateEmail}`,
    null,
    {
      withCredentials: true,
    }
  );

  return response;
};

// logout action
export const logoutAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/logout?affiliateEmail=${payload.email}`
  );
  localStorage.removeItem("firstlogin");
  return response;
};

// get affiliate details
export const getAffiliateDetailsAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/affiliates/@me`,
    {
      headers: {
        Authorization: `${payload}`,
      },
      withCredentials: true,
    }
  );

  return response;
};
